import api from '@/lib/api';
import { ROUTES } from '@/constants/routes';
import type {
  FeeSharingConfig,
  FeeSharingConfigPayload,
  FeeSharingStatus,
  ResetFixedUsagePayload,
  ResetFixedUsageResponse,
} from '@/types/fee-sharing';

const mattersBase = ROUTES.API.MATTERS;

/**
 * Fee Sharing Config CRUD — nested under /api/matters/{matterId}/fee-sharing-configs/
 */

export async function listFeeSharingConfigs(matterId: number): Promise<FeeSharingConfig[]> {
  const res = await api.get(`${mattersBase}${matterId}/fee-sharing-configs/`);
  return res.data.results ?? res.data;
}

export async function getFeeSharingConfig(matterId: number, configId: number): Promise<FeeSharingConfig> {
  const res = await api.get(`${mattersBase}${matterId}/fee-sharing-configs/${configId}/`);
  return res.data;
}

export async function createFeeSharingConfig(matterId: number, payload: FeeSharingConfigPayload): Promise<FeeSharingConfig> {
  const res = await api.post(`${mattersBase}${matterId}/fee-sharing-configs/`, payload);
  return res.data;
}

export async function updateFeeSharingConfig(matterId: number, configId: number, payload: FeeSharingConfigPayload): Promise<FeeSharingConfig> {
  const res = await api.put(`${mattersBase}${matterId}/fee-sharing-configs/${configId}/`, payload);
  return res.data;
}

export async function deleteFeeSharingConfig(matterId: number, configId: number): Promise<void> {
  await api.delete(`${mattersBase}${matterId}/fee-sharing-configs/${configId}/`);
}

/**
 * Fee Sharing Status
 */
export async function getFeeSharingStatus(matterId: number, asOf?: string): Promise<FeeSharingStatus> {
  const params = asOf ? `?as_of=${asOf}` : '';
  const res = await api.get(`${mattersBase}${matterId}/fee-sharing-status/${params}`);
  return res.data;
}

/**
 * Reset fixed-amount usage
 */
export async function resetFixedUsage(matterId: number, payload?: ResetFixedUsagePayload): Promise<ResetFixedUsageResponse> {
  const res = await api.post(`${mattersBase}${matterId}/reset-fixed-usage/`, payload ?? {});
  return res.data;
}
